import React, { useState } from 'react';
// material
import { styled } from '@mui/material/styles';
import { Card, Typography, Box, Snackbar, Alert } from '@mui/material';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import { LoginForm } from '../components/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100% !important'
}));

// ----------------------------------------------------------------------

export default function Login() {
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'center',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'top';
  const horizontal = 'center';

  return (
    <RootStyle title="Login">
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '90%',
          gap: '100px'
        }}
      >
        <MHidden width="mdDown">
          <Box
            sx={{
              width: '456px',
              height: '456px'
            }}
          >
            <img
              src="https://www.proxgy.com/assets/products/locket/product.png"
              alt="login"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </Box>
        </MHidden>

        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
            gap: '30px',
            width: '350px',
            height: '100%',
            borderRadius: '10px',
            backgroundColor: '#F8FAFB !important'
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '700',
              lineHeight: '20px',
              textAlign: 'left'
            }}
          >
            Log In
          </Typography>
          <LoginForm alertMetas={alertMetas} setAlertMetas={setAlertMetas} />
        </Card>
      </Box>
    </RootStyle>
  );
}
